
<template>
  <div v-if="isLoading" class="loader-overlay">
    <div class="loader-container">
      <div class="loader"></div>
    </div>
  </div>
</template>
<script>
import { isLoading } from "../api";

export default {
  name: "LoaderComponent",
  setup() {
    return { isLoading };
  },
};
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 193, 7, 0.457); /* خلفية صفراء شفافة */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader {
  width: 90px;
  height: 50px;
  background: orange;
  position: relative;
  animation: l9-0 1.5s infinite linear;
}

.loader:before,
.loader:after {
  content: "";
  position: absolute;
  background: inherit;
  bottom: 100%;
  width: 50%;
  height: 100%;
  animation: inherit;
  animation-name: l9-1;
}

.loader:before {
  left: 0;
  transform-origin: bottom left;
  --s: -1;
}

.loader:after {
  right: 0;
  transform-origin: bottom right;
}
@keyframes l9-0 {
  0%, 10% {
    transform: translateY(0%) scaleY(1);
  }
  49.99% {
    transform: translateY(-50%) scaleY(1);
  }
  50% {
    transform: translateY(-50%) scaleY(-1);
  }
  90%, 100% {
    transform: translateY(-100%) scaleY(-1);
  }
}

@keyframes l9-1 {
  10%, 90% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(calc(var(--s, 1) * 180deg));
  }
}
</style>